/**
 * Formats a Recharts tooltip label as a readable date.
 *
 * Recharts 3 types the `labelFormatter` argument as `ReactNode`, because a
 * label can legitimately be an element. Our time-series charts always feed it
 * the ISO date string from the x-axis, but the type can't know that — so the
 * narrowing happens here rather than being repeated at each chart, and a
 * label that isn't date-like degrades to an empty string instead of rendering
 * "Invalid Date" over the tooltip.
 */
export function formatChartDateLabel(value) {
    if (typeof value !== 'string' && typeof value !== 'number') {
        return '';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}
